import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=18a3f279&scoped=true&"
import script from "./UserDetails.vue?vue&type=script&lang=js&"
export * from "./UserDetails.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserDetails.vue?vue&type=style&index=1&id=18a3f279&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a3f279",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAvatar,VBtn,VCheckbox,VDivider,VIcon,VList,VListItem,VMenu,VProgressLinear})
